import { createReducer } from "typesafe-actions";

import { DashboardState } from "../../../types";
import { Actions } from "../../../store/epics";
import {
  createModelRequest,
  getDashboardAction,
  getUnverifiedPhysicansAction,
  loadUnverifiedPhysicians,
} from "./actions";
import { Model, ModelName } from "../../../models";

const models: ModelName[] = [
  "activity",
  "patient",
  "physician",
  "lab",
  "pharmacy",
  "appointment",
  "rating",
  "tag",
  "transaction",
  "contractor",
  "request",
  "invite",
  "prescription",
  "questionnaire",
  "affiliate",
  "discount",
  'organization',
  'admin'
];

const initialModel:  Record<ModelName, {model?: Model, loading: boolean}> = 
models.reduce<Record<ModelName, {model?: Model, loading: boolean}>>((m, v ) => ({...m, [v]:  {
    loading: false,
  }}), {} as any);

const initialState: DashboardState = {
  unverifiedPhysicians: 0,
  totalMeetingsScheduled: 0,
  totalMeetingsCompleted: 0,
  totalMeetingsCancelled: 0,
  totalMeetingsPending: 0,
  errorMessage: "",
  loading: false,
  "is-loading-physicians": false,
  createdModels: initialModel
};

export default createReducer<DashboardState, Actions>(initialState)
  .handleAction(getDashboardAction.request, (state) => {
    return {
      ...state,
      loading: true,
    };
  })
  .handleAction(getUnverifiedPhysicansAction.request, (state) => {
    return {
      ...state,
      "is-loading-physicians": true,
    };
  })
  .handleAction(getUnverifiedPhysicansAction.success, (state, { payload }) => {
    return {
      ...state,
      "is-loading-physicians": false,
      unverifiedPhysicians: payload,
    };
  })
  .handleAction(getUnverifiedPhysicansAction.failure, (state, { payload }) => {
    return {
      ...state,
      "is-loading-physicians": false,
      "physician-error-message": payload,
    };
  })
  .handleAction(loadUnverifiedPhysicians, (state, { payload }) => {
    return {
      ...state,
      unverifiedPhysicians: payload,
    };
  })

  .handleAction(
    [getDashboardAction.success, getDashboardAction.failure],
    (state, { payload }) => {
      return {
        ...state,
        loading: false,
        totalMeetingsScheduled:
          payload.Scheduled || state.totalMeetingsScheduled,
        totalMeetingsCancelled:
          payload.Cancelled || state.totalMeetingsCancelled,
        totalMeetingsCompleted:
          payload.Completed || state.totalMeetingsCompleted,
        totalMeetingsPending: payload.Pending || state.totalMeetingsCompleted,
      };
    }
  )
  .handleAction(createModelRequest.request, (state, { payload }) => {
    return {
      ...state,
      createdModels: {
        ...state.createdModels,
        [payload.modelName]: {
          model: undefined,
          loading: true,
        },
      },
    };
  })
  .handleAction(createModelRequest.failure, (state, { payload }) => {
    return {
      ...state,
      createdModels: {
        ...state.createdModels,
        [payload.modelName]: {
          model: undefined,
          loading: false,
        },
      },
    };
  })
  .handleAction(createModelRequest.success, (state, { payload }) => {
    return {
      ...state,
      createdModels: {
        ...state.createdModels,
        [payload.modelName]: {
          model: payload.model,
          loading: false,
        },
      },
    };
  });
